/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const CMDSERIES = ['COMMAND_SERIES_V2', 'COMMAND_SERIES_V3', 'COMMAND_BATCH'];
